<template>
    <div class="row">
        <div class="col-xs-12">
            <div class="custom-question">
                {{ question.question }} <span class="custom-question-required" v-show="question.required">*</span>
            </div>
            <input type="text"
                   class="form-control"
                   :disabled="disabled"
                   v-show="question.response_type === 'text'"
                   v-model="textResponse" />
            <select v-show="question.response_type === 'select'"
                    class="form-control"
                    :disabled="disabled"
                    v-model="selectResponse">
                <option :value="''" disabled>Please Select An Option</option>
                <option v-for="selection in orderedSelections" :value="selection.value">
                    {{ selection.value }}
                </option>
            </select>
        </div>
    </div>
</template>

<script>
    import debounce from 'lodash/debounce';

    export default {
        props: ['question', 'answer', 'disabled', 'clear'],
        data() {
            return {
                textResponse: (this.answer && this.question.response_type === 'text') ? this.answer : '',
                selectResponse: (this.answer && this.question.response_type === 'select') ? this.answer : ''
            }
        },
        watch: {
            textResponse(response) {
                this.processTextResponse(response);
            },
            selectResponse(response) {
                if( ! response) {
                    return;
                }
                this.$emit('answered', {answer: response, question: this.question});
            },
            clear(time) {
                if(time) {
                    this.textResponse = '';
                    this.selectResponse = '';
                }
            }
        },
        methods: {
            processTextResponse: debounce(function(response) {
                if( ! response) {
                    this.$emit('cleared', this.question);
                    return;
                }
                this.$emit('answered', {answer: response, question: this.question});
            }, 500)
        },
        computed: {
            orderedSelections() {
                if( ! this.question.selections) {
                    return [];
                }
                return this.question.selections.slice().sort((selectionA, selectionB) => {
                    if(selectionA.order === selectionB.order) {
                        return 0;
                    }
                    return selectionA.order > selectionB.order ? 1 : -1;
                });
            }
        }
    }
</script>

<style scoped>
    .custom-question {
        font-size: 18px;
        font-weight: 600;
        margin-bottom: 10px;
    }
    .custom-question-required {
        color: red;
    }
</style>
